// extracted by mini-css-extract-plugin
export default {"screen":"LoadingScreen_screen__ojmF8","content":"LoadingScreen_content__C1bw3","spinner":"LoadingScreen_spinner__n7bbV","text":"LoadingScreen_text__D8v7f"};